import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../Navigation';
import Footer from '../Footer';

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="landing-page bg-background min-h-screen">
      <Navigation />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Terms of{' '}
            <span className="bg-gradient-to-r from-[#FF56A5] via-[#E852FF] to-[#9F44F2] bg-clip-text text-transparent">
              Service
            </span>
          </h1>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Please read these terms carefully before using our services
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-1">
            <div className="bg-gradient-to-br from-[#FF56A5]/20 via-[#E852FF]/20 to-[#9F44F2]/20 rounded-2xl p-8">
              <div className="space-y-8 text-gray-300">
                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">1. Agreement to Terms</h2>
                  <p>
                    By accessing or using Lifelike Agents' services, you agree to be bound by these Terms of Service
                    and all applicable laws and regulations. If you do not agree with any of these terms, you
                    are prohibited from using or accessing our service.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">2. Use License</h2>
                  <div className="space-y-4">
                    <p>
                      Subject to your compliance with these Terms, Lifelike Agents grants you a limited, non-exclusive,
                      non-transferable, non-sublicensable license to access and use our services for your
                      business purposes.
                    </p>
                    <div>
                      <h3 className="text-xl font-semibold text-white mb-2">Restrictions:</h3>
                      <ul className="list-disc ml-6 space-y-2">
                        <li>You must not modify or copy our software</li>
                        <li>You must not attempt to reverse engineer our platform</li>
                        <li>You must not use our service for any illegal purposes</li>
                        <li>You must not transmit any malicious code or harmful data</li>
                      </ul>
                    </div>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">3. Service Description</h2>
                  <p>
                    Lifelike Agents provides an AI-powered communication platform that enables automated phone calls,
                    chat interactions, and other communication services. We reserve the right to modify,
                    suspend, or discontinue any part of our service at any time.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">4. User Responsibilities</h2>
                  <ul className="list-disc ml-6 space-y-2">
                    <li>Maintain accurate account information</li>
                    <li>Protect account credentials</li>
                    <li>Comply with all applicable laws and regulations</li>
                    <li>Use the service responsibly and ethically</li>
                    <li>Pay all fees and charges on time</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">5. Payment Terms</h2>
                  <p>
                    You agree to pay all fees associated with your use of our services. Fees are non-refundable
                    except as required by law or as explicitly stated in our refund policy.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">6. Intellectual Property</h2>
                  <p>
                    All content, features, and functionality of our service are owned by Lifelike Agents and are
                    protected by international copyright, trademark, patent, trade secret, and other
                    intellectual property laws.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">7. Limitation of Liability</h2>
                  <p>
                    Lifelike Agents shall not be liable for any indirect, incidental, special, consequential, or
                    punitive damages resulting from your use of or inability to use the service.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">8. Termination</h2>
                  <p>
                    We may terminate or suspend your account and access to our service immediately, without
                    prior notice, for any breach of these Terms of Service.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">9. Governing Law</h2>
                  <p>
                    These Terms shall be governed by and construed in accordance with the laws of the United
                    States, without regard to its conflict of law provisions.
                  </p>
                </section>

                <div className="mt-8 pt-8 border-t border-white/10">
                  <p className="text-gray-400 text-sm">
                    Last Updated: February 19, 2024
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfService; 